<template>
  <div :class="{'flex':type==='buttons'}">
    <BaseRadio v-for="(option,i) in options" :key="i"
               :class="`--${type}`"
               :model-value="value"
               :disabled="!!option.disabled"
               :value="option.value"
               @change="$emit('change',$event)">
      {{ option[label] }}
    </BaseRadio>
  </div>
</template>

<script>
import BaseRadio from "@/components/UI/BaseRadio";

export default {
  name: "BaseRadioGroup",
  components: {BaseRadio},
  props: {
    options: {
      type: Array
    },
    value: {
      type: [Number, String, Boolean],
      required: true
    },
    type: {
      type: String,
      default: 'classic',
      validator: (val) => ['classic', 'buttons'].includes(val)
    },
    label:{
      type:String,
      default:'label'
    }
  }
}
</script>